import React from "react";

const FaqSection = () => {
  return (
    <section className="faq-page-area pt-2 pb-10">
      <div className="">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="text-center mb-5">
              <h2 className="faq-title">Frequently Asked Questions</h2>
            </div>

            <div className="accordion" id="faqAccordion">
              {/* FAQ 1 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false"
                    aria-controls="collapse1"
                  >
                    1. How can I book the hotel rooms of JTDCL?
                  </button>
                </h2>
                <div
                  id="collapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading1"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body" style={{ lineHeight: "2.2" }}>
                    <ol type="1">
                      <li>
                        First, create an account or sign in at{" "}
                        <a
                          href="/login"
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            color: "blue",
                            textDecoration: "none",
                          }}
                          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                        >
                          https://jtdcl.jharkhand.gov.in
                        </a>
                      </li>
                      <li>
                        Go to the{" "}
                        <a
                          href="/allhotel"
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            color: "blue",
                            textDecoration: "none",
                          }}
                          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                        >
                          HOTEL
                        </a>{" "}
                        section or Homepage and browse the list.
                      </li>
                      <li>Select your preferred hotel to open its details page.</li>
                      <li>Click <b>Check Availability</b> for your chosen date.</li>
                      <li>If available, click <b>Book Now</b>.</li>
                      <li>
                        Fill in all required booking details and select your date and room.
                      </li>
                      <li>
                        Make payment using Debit Card / Credit Card or UPI.
                      </li>
                      <li>
                        After successful payment, download/print the booking confirmation.
                      </li>
                      <li>
                        Visit the hotel with the printed booking confirmation and a valid ID
                        proof.
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* FAQ 2 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse2"
                    aria-expanded="false"
                    aria-controls="collapse2"
                  >
                    2. Do I need to create an account to book a hotel?
                  </button>
                </h2>
                <div
                  id="collapse2"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading2"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body" style={{ lineHeight: "2.2" }}>
                    <ol type="1">
                      <li>
                        Yes, you must first{" "}
                        <a
                          href="/signup"
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            color: "blue",
                            textDecoration: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.textDecoration = "underline")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.textDecoration = "none")
                          }
                        >
                          create an account
                        </a>{" "}
                        on the website before booking.
                      </li>
                      <li>
                        During registration, both your email and mobile number will be
                        verified via OTP.
                      </li>
                      <li>
                        Once your account is created, you can log in anytime to book, manage,
                        or cancel your hotel reservations.
                      </li>
                      <li>
                        This process ensures secure bookings and helps you keep a proper
                        record of all your transactions.
                      </li>
                      <li>
                        If you are an <strong>existing user from the old website</strong>, you
                        don’t need to create a new account. Simply use the{" "}
                        <a
                          href="/forgot-password"
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            color: "blue",
                            textDecoration: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.textDecoration = "underline")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.textDecoration = "none")
                          }
                        >
                          Forgot Password
                        </a>{" "}
                        option. After verifying your registered email ID (used in your
                        previous booking), you can reset your password and access your account
                        on the new portal.
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* FAQ 3 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading3">
                  <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse3"
                    aria-expanded="false"
                    aria-controls="collapse3"
                  >
                    3. How can I book tour packages of JTDCL?
                  </button>
                </h2>
                <div
                  id="collapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading3"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body" style={{ lineHeight: "2.2" }}>
                    <ol type="1">
                      <li>
                        Go to the hamburger menu <b>(☰)</b> or sidebar menu and select the Explore Jharkhand menu.
                      </li>
                      <li>
                        Click on the{" "}
                        <a
                          href="/tours"
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            color: "blue",
                            textDecoration: "none",
                          }}
                          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                        >
                          Tour Packages
                        </a>{" "}
                        option to view available packages.
                      </li>
                      <li>Browse through the list of tours and choose your preferred package.</li>
                      <li>Click on <b>Book Now</b> for the selected tour.</li>
                      <li>Fill in the required information and submit the form.</li>
                      <li>
                        The related tour manager/admin will automatically get a notification
                        and contact you for further process.
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* FAQ 4 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading4">
                  <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse4"
                    aria-expanded="false"
                    aria-controls="collapse4"
                  >
                    4. How can I cancel the booked hotel room of JTDCL?
                  </button>
                </h2>
                <div
                  id="collapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading4"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body" style={{ lineHeight: "2.2" }}>
                    <ol type="1">
                      <li>
                        Go to{" "}
                        <a
                          href="/login"
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            color: "blue",
                            textDecoration: "none",
                          }}
                          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                        >
                          https://jtdcl.jharkhand.gov.in
                        </a>{" "}
                        and sign in.
                      </li>
                      <li>Open the hamburger menu <b>(☰)</b> or sidebar menu and click on Hotel Services.</li>
                      <li>From Hotel Services, go to Booking History.</li>
                      <li>Select the booking you want to cancel.</li>
                      <li>
                        Click on the Cancel option and confirm your cancellation request.
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* FAQ 5 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading6">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse6"
                    aria-expanded="false"
                    aria-controls="collapse6"
                  >
                    5. How can I book for group stays, bulk reservations, or Shaadi (wedding)
                    packages?
                  </button>
                </h2>
                <div
                  id="collapse6"
                  className="accordion-collapse collapse"
                  aria-labelledby="heading6"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body" style={{ lineHeight: "2.2" }}>
                    <ol type="1">
                      <li>
                        JTDCL hotels accept group bookings, bulk reservations, and Shaadi
                        (wedding) packages.
                      </li>
                      <li>
                        These bookings may include multiple rooms, banquet halls, catering,
                        and other event facilities.
                      </li>
                      <li>
                        You can request such bookings in two ways:
                        <ul className="ms-4">
                          <li>
                            By submitting a request through the{" "}
                            <a
                              href="/advanceBooking"
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                color: "blue",
                                textDecoration: "none",
                              }}
                              onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                            >
                              Package Booking
                            </a>{" "}
                            section in the website footer.
                          </li>
                          <li>Or by directly contacting the hotel manager for customized arrangements.</li>
                        </ul>
                      </li>
                      <li>
                        Please share complete details such as number of guests, dates, room
                        requirements, and special needs.
                      </li>
                      <li>
                        Our reservations/events team will confirm availability, provide
                        package options, and guide you on advance payment.
                      </li>
                      <li>
                        Early booking is recommended, especially for Shaadi packages, to
                        secure dates and facilities.
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
